export const ExpandMoreIcon = () => {
    return (
        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M32.8789 16.44C32.8789 7.36107 25.5178 0 16.4389 0C7.35998 0 -0.00108935 7.36107 -0.00108935 16.44C-0.00108935 25.5189 7.35998 32.88 16.4389 32.88C25.5178 32.88 32.8789 25.5189 32.8789 16.44ZM23.5618 12.0357V16.9484L16.4389 22.1234L9.3133 16.9511L9.3133 12.0357L16.4389 17.2079L23.5618 12.0357Z" fill="#142440" />
        </svg>
    )
}
